import * as React from "react"
const SvgPdfFile = props => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="currentColor"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      d="M8 17.571h1a.97.97 0 0 0 .713-.287.97.97 0 0 0 .287-.714v-1a.97.97 0 0 0-.287-.712A.97.97 0 0 0 9 14.57H7.5a.48.48 0 0 0-.35.15.48.48 0 0 0-.15.35v4q0 .2.15.35a.48.48 0 0 0 .7 0q.15-.15.15-.35v-1.5Zm0-1v-1h1v1zm5 3a.97.97 0 0 0 .713-.287.97.97 0 0 0 .287-.714v-3a.97.97 0 0 0-.287-.712.97.97 0 0 0-.713-.288h-1.5a.48.48 0 0 0-.35.15.48.48 0 0 0-.15.35v4q0 .2.15.35t.35.15H13Zm-1-1v-3h1v3z"
      clipRule="evenodd"
    />
    <path d="M16 17.571h.5a.48.48 0 0 0 .35-.15.48.48 0 0 0 0-.7.48.48 0 0 0-.35-.15H16v-1h.5a.48.48 0 0 0 .35-.15.48.48 0 0 0 0-.7.48.48 0 0 0-.35-.15h-1a.48.48 0 0 0-.35.15.48.48 0 0 0-.15.35v4q0 .2.15.35a.48.48 0 0 0 .7 0q.15-.15.15-.35z" />
    <path
      fillRule="evenodd"
      d="M4.588 21.984q.587.587 1.412.587h12q.824 0 1.413-.587A1.93 1.93 0 0 0 20 20.571V9.396a1.98 1.98 0 0 0-.575-1.4l-4.85-4.85a1.98 1.98 0 0 0-1.4-.575H6q-.824 0-1.412.588A1.93 1.93 0 0 0 4 4.57v16q0 .825.588 1.413ZM13 4.57v4a.97.97 0 0 0 .287.713q.288.287.713.287h4v11H6v-16z"
      clipRule="evenodd"
    />
  </svg>
)
export default SvgPdfFile
